import { Injectable } from '@angular/core';
import { DataService } from '../../data/data.service';
import { map, tap, debounce, debounceTime, filter } from 'rxjs/operators';
import { AuthService } from '../../auth/auth.service';
import { CUSTOMER_NAV_ITEMS, ALL_USERS_NAV_ITEMS } from './side-nav.const';
import { getRoutesByGroup } from '../../auth/user-group-guard.provider';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { Roles } from '../../auth/user-group-guard.provider';
import { ISideNavItem } from './side-nav-item/side-nav-item.model';

@Injectable({
  providedIn: 'root'
})
export class SideNavRoutesService {
  user$ = this.auth.token$.pipe(map(token => this.auth.getUser()));
  group$ = this.user$.pipe(map((user: any) => (user && user.group) || []));
  userGroup$ = new BehaviorSubject<string[]>([]);
  isAdmin$ = new BehaviorSubject<boolean>(false);
  reRenderSideNav$ = new Subject<void>();
  dataSrc = {
    alerts$: this.data.alertsList()
      .pipe(map((res: any) => res && res.length)),
  };

  private createCustomerNavItems(customer: any){
    return this.group$.pipe(
      debounceTime(500),
      filter(group => group && group.length),
      map(group => {
        var user = this.auth.getUser();
        var customerNavItem = CUSTOMER_NAV_ITEMS;
        
        if(user && user.account && !user.account.enable_power_bi_reports) {
          customerNavItem = customerNavItem.filter(item => item.name != 'Utility Bills Dashboard');
        }
        
        if(customer && !customer.enable_power_bi_reports) {
          customerNavItem = customerNavItem.filter(item => item.name != 'Utility Bills Dashboard');
        }

        if(!customer || !customer.enable_cass) {
          customerNavItem = customerNavItem.filter(item => item.name != 'Cass Accounts');
        }

        return getRoutesByGroup(customerNavItem, group);
      }),
      map(routes => routes.map((route) => ({...route, data$: route.dataSrc && this.dataSrc[route.dataSrc]}))),
    );
  }

  private createAllUsersRoutes(customer: any){
    return this.group$.pipe(
      debounceTime(500),
      filter(group => group && group.length),
      map(group => {
        var user = this.auth.getUser();
        var allUsersNavItems = ALL_USERS_NAV_ITEMS;
        
        if(user && user.account && !user.account.enable_power_bi_reports) {
          allUsersNavItems = allUsersNavItems.filter(item => item.name != 'Utility Bills Dashboard');
        }
        
        if(customer && !customer.enable_power_bi_reports) {
          allUsersNavItems = allUsersNavItems.filter(item => item.name != 'Utility Bills Dashboard');
        }

        return getRoutesByGroup(allUsersNavItems, group)
      }),

      map(routes => routes.map((route) => ({...route, data$: route.dataSrc && this.dataSrc[route.dataSrc]}))),
    );
  }

  constructor(private data: DataService, private auth: AuthService) {}

  initRoutes(user: any, customer: any) {
    const userGroup = (user && user.group) || [];
    const isAdmin = userGroup.indexOf(Roles.superuser) > -1;
    this.userGroup$.next(userGroup);
    this.isAdmin$.next(isAdmin);

    var customerNavItems =  this.createCustomerNavItems(customer);
    var allUsersRoutes =  this.createAllUsersRoutes(customer);
   
    return {
      customerNavItems$: customerNavItems,
      allUsersRoutes$: allUsersRoutes,
    };
  }

  triggerReRender() {
    this.reRenderSideNav$.next(); // Emit an event to notify re-render
  }
}
